import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { useFormik } from 'formik';

import MembershipSettingPresenter, {
  TYPES,
} from '../../../../../presenters/MembershipSettingPresenter';
import { apiErrorsToFormik } from '../../../../../utils/formUtils';
import {
  validationSchema,
  initialValues,
} from '../../../../../forms/membershipSettingForm';
import Label from '../../../../../components/Label';
import Row from '../../../../../components/Row';
import Column from '../../../../../components/Column';
import Input from '../../../../../components/Input';
import Select from '../../../../../components/Select';
import Button from '../../../../../components/Button';

const EditSettingForm = (props) => {
  const { onSubmit, apiErrors, onModalClose, currentMembershipSetting } = props;

  const options = Object.values(TYPES).map((settingType) => {
    return {
      value: settingType,
      label: MembershipSettingPresenter.settingTypeReadable({ settingType }),
    };
  });

  const defaultOption = { value: '', label: '-- Choose setting type--' };

  const handleSettingChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  const handleUpdateSetting = async (values, actions) => {
    actions.setSubmitting(true);
    const settingId = MembershipSettingPresenter.id(currentMembershipSetting);

    await onSubmit(settingId, values);
    actions.setSubmitting(false);
    actions.resetForm();
    onModalClose();
  };

  const formik = useFormik({
    initialValues: initialValues(currentMembershipSetting),
    onSubmit: handleUpdateSetting,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, values, setFieldValue, errors, setErrors } = formik;

  useEffect(() => {
    if (!isNil(apiErrors)) {
      setErrors(apiErrorsToFormik(apiErrors));
    }
    return () => {
      setErrors({});
    };
  }, [apiErrors]);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Column>
          <div>
            <Label name="settingType" title="Setting Type" errors={errors} />
            <Select
              id="settingType"
              value={values.settingType}
              options={options}
              defaultOption={defaultOption}
              onChange={handleSettingChange}
              disabled
              required
            />
          </div>
          <div>
            <Label name="description" title="Description" errors={errors} />
            <Input
              id="description"
              value={values.description}
              onChange={handleSettingChange}
            />
          </div>
          <div>
            <Label name="value" title="Value" errors={errors} />
            <Input
              type="number"
              step="0.01"
              id="value"
              value={values.value}
              onChange={handleSettingChange}
              required
            />
          </div>
        </Column>
      </Row>
      <div className="modal-actions">
        <Button className="modal-save" type="submit">
          Update
        </Button>
        <Button className="modal-close" onClick={onModalClose}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default EditSettingForm;

EditSettingForm.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  apiErrors: PropTypes.shape(),
  currentMembershipSetting: MembershipSettingPresenter.shape().isRequired,
};

EditSettingForm.defaultProps = {
  apiErrors: {},
};
